module.exports = __webpack_public_path__ + "img/pt1.0578dbeb.png";